import React, { useState } from "react";
import { Layout as AntLayout } from "antd";
import Header from "../Header";
import Sidebar from "../Sidebar";

const { Sider, Content } = AntLayout;

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <AntLayout style={{ minHeight: "100vh" }}>
      <Header />
      <AntLayout>
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          theme="dark"
          width={220}
          collapsedWidth={64}
          style={{
            overflow: "auto",
            height: "calc(100vh - 64px)",
            position: "sticky",
            top: 64,
            left: 0,
          }}
        >
          <Sidebar collapsed={collapsed} />
        </Sider>
        <Content
          style={{
            padding: "24px",
            minHeight: "calc(100vh - 64px)",
            background: "#f5f5f5",
          }}
        >
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
